import { NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DsBadgeComponent } from '@design-system/ds-badge/component/ds-badge.component';
import { DsInputComponent } from '@design-system/ds-input/component/ds-input.component';
import { DsSelectComponent } from '@design-system/ds-select/component/ds-select.component';
import { DsTextComponent } from '@design-system/ds-text/component/ds-text.component';
import { BaseDropdownInterface } from '@interfaces/base-dropdown.interface';
import { BtrSectionTitleComponent } from '../../btr-section-title/component/btr-section-title.component';
import { BlockTimeLegEnum } from '../../../enums/block-time-leg.enum';
import { compareDropdownById } from '../../../helpers/compare-dropdown-by-id.helper';
import { BlockTimeHoursCardInterface } from '../../../interfaces/block-time-hours-card.interface';
import { BlockTimeLegRowInterface } from '../../../interfaces/block-time-leg-row.interface';
import {
  BLOCK_TIME_HOURS_ERROR,
  BLOCK_TIME_LEG_CONTROLS,
  BLOCK_TIME_NOT_COUNTED,
} from '../../../properties/block-time-record-modal.properties';
import { BlockTimeHoursFormGroup } from '../../../types/block-time-record-form.type';

/**
 * Shows one hours card: the leg rows, the optional cancellation row and the total.
 * In add mode, the actual card shows inputs and the estimated card shows the estimated total input.
 */
@Component({
  selector: 'app-btr-hours-card',
  templateUrl: './btr-hours-card.component.html',
  styleUrls: ['./btr-hours-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    ReactiveFormsModule,
    MatFormFieldModule,
    DsBadgeComponent,
    DsInputComponent,
    DsSelectComponent,
    DsTextComponent,
    BtrSectionTitleComponent,
  ],
})
export class BtrHoursCardComponent {
  @Input() card: BlockTimeHoursCardInterface | null = null;
  /** A unique id prefix for the headings and the inputs of this card. */
  @Input() cardId = 'btr_hours';
  /** The section number in the modal. */
  @Input() step = 1;
  @Input() isCancellationVisible = false;
  @Input() cancellationHours = '';
  /** The form group of the add mode. The value is null in edit mode. */
  @Input() hoursGroup: BlockTimeHoursFormGroup | null = null;
  /** True for the actual card. The leg inputs show only on the actual card in add mode. */
  @Input() isActual = false;
  @Input() airportOptions: BaseDropdownInterface[] = [];
  /** The modal increments this value after an invalid save, so that this OnPush view shows the field errors. */
  @Input() validationRun = 0;

  readonly ibLeg = BlockTimeLegEnum.IbRepo;
  readonly legControls = BLOCK_TIME_LEG_CONTROLS;
  readonly notCountedText = BLOCK_TIME_NOT_COUNTED;
  readonly hoursError = BLOCK_TIME_HOURS_ERROR;
  readonly compareById = compareDropdownById;
  readonly titleColor = 'var(--tac-primary-title-color)';

  trackByLeg(_index: number, row: BlockTimeLegRowInterface): BlockTimeLegEnum {
    return row.leg;
  }
}
